import React from 'react';

const NoMatchPage = () => {
  return (
    <>
      404: This page does not exist.
    </>
  );
}

export default NoMatchPage;

NoMatchPage.propTypes = {}

NoMatchPage.defaultProps = {}